import { v4 as uuid } from 'uuid';

let sessionId: string | undefined;

/**
 * Returns the identifier shared by requests in the current registration session.
 * It is intentionally kept in memory so a new app process starts a new session.
 */
export function getSessionId(): string {
  sessionId ??= uuid();

  return sessionId;
}

/** Starts a fresh session the next time a request needs an identifier. */
export function resetSessionId(): void {
  sessionId = undefined;
}
